/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { MutableRefObject, useEffect, useRef, useState } from 'react'

export const useHover = <T>(): [MutableRefObject<T>, boolean] => {
  const [hovered, setHovered] = useState<boolean>(false)
  const ref: any = useRef<T | null>(null)
  const handleMouseEnter = (): void => setHovered(true)
  const handleMouseLeave = (): void => setHovered(false)

  useEffect(
    () => {
      const node: any = ref.current
      if (node) {
        node.addEventListener('mouseenter', handleMouseEnter)
        node.addEventListener('mouseleave', handleMouseLeave)
        return () => {
          node.removeEventListener('mouseenter', handleMouseEnter)
          node.removeEventListener('mouseleave', handleMouseLeave)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ref.current] // Recall only if ref changes
  )
  return [ref, hovered]
}
